import React from 'react';
import LegalPolicyLayout from './legal-policy-layout';

export default class LegalPolicy extends React.Component<{}, {}> {
    render(){
        return(
            <LegalPolicyLayout/>
        )
    }
}